import { render, staticRenderFns } from "./MyCoursesTables.vue?vue&type=template&id=33cb0839&"
import script from "./MyCoursesTables.vue?vue&type=script&lang=js&"
export * from "./MyCoursesTables.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cb0839')) {
      api.createRecord('33cb0839', component.options)
    } else {
      api.reload('33cb0839', component.options)
    }
    module.hot.accept("./MyCoursesTables.vue?vue&type=template&id=33cb0839&", function () {
      api.rerender('33cb0839', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesTables.vue"
export default component.exports